export { PagesListItemComponent } from './pages-list-item/pages-list-item.component';
